export const ReservationBtnUrl =
  'https://docs.google.com/forms/d/1gLeZhd-5Y6wdfgMzVtbKqYqqOZS_usBjnQK-mSX2Cw4/edit';
